import React, { FC, useEffect, useState } from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Check from '../Assets/Images/check.png';
import { useGlobalState } from '../GlobalStateContext';

interface ThankYouCardProps {
	onClose: () => void;
}

const ThankYouCard: FC<ThankYouCardProps> = ({ onClose }) => {
	const { state: globalState } = useGlobalState();
	const [isClosing, setIsClosing] = useState(false);
	const [countdown, setCountdown] = useState(10);

	useEffect(() => {
		const timer = setTimeout(() => {
			if (countdown > 0) {
				setCountdown((prevCountdown) => prevCountdown - 1);
			} else {
				setIsClosing(true);
				onClose();
			}
		}, 1000);

		return () => clearTimeout(timer);
	}, [countdown, onClose]);

	const demoCardStyle = {
		width: '100%',
		maxWidth: 500,
		maxHeight: 500,
		marginTop: '1rem',
		marginLeft: 'auto',
		marginRight: 'auto',
		overflow: 'auto',
		position: 'relative',
		border: 'none',
		boxShadow: 'none',
		borderRadius: '24px',
		padding: '24px',
		display: isClosing ? 'none' : 'block',
	};

	const cardStyle = {
		maxWidth: 400,
		maxHeight: 500,
		marginTop: '1rem',
		marginLeft: '3rem',
		overflow: 'auto',
		position: 'relative',
		border: '1px solid #ccc',
		display: isClosing ? 'none' : 'block',
	};

	const titleStyle = { margin: '0.5em 0.1em 0em  0.1em' };
	const demoTitleStyle = { margin: '0.5rem 0', fontSize: '24px' };
	const demoParagraphStyle = { margin: '0.5rem 0', fontSize: '16px' };
	const paragraphStyle = { margin: '0.3em 0.1em 0.2em 0.1em' };
	const helperStyle = { margin: '0em 0.1em 0.5em 0.1em' };
	const demoHelperStyle = { margin: '0' };

	return (
		<Card
			sx={demoCardStyle}
		>
			<CardContent style={{ textAlign: 'center' }}>
				<img src={Check} width="80" height="80"></img>
				<Typography variant="h6" gutterBottom sx={demoTitleStyle}>
					¡Datos recibidos!
				</Typography>
				<Typography variant="h6" gutterBottom sx={demoParagraphStyle}>
					Te contactaremos lo más pronto posible.
				</Typography>
				<Typography
					variant="body2"
					color="textSecondary"
					style={demoHelperStyle}
				>
					Cerrando en {countdown} segundos...
				</Typography>
			</CardContent>
		</Card>
	);
};

export default ThankYouCard;
